<script>
import ModelShow from "../models/show";
import ColumnComponent from "./show/column-component";

export default {
  extends: ModelShow,
  page: {
    title: "Detail Nota Bongkar"
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("unloads.singular"));
      }
    },
    resourceRoute: { default: "unload" },
    modelVariable: { default: "unload" },
    denyEdit: { type: Boolean, default: false },
    denyDelete: { type: Boolean, default: true },
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || "model"]: [
            {
              key: "key",
              label: this.$t("models.key"),
              component: ColumnComponent
            }
          ]
        };
      }
    }
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t("unloads.plural"))
    };
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t("unloads.plural")),
          href: "/unload"
        },
        {
          text: this.model && this.model.id ? this.model.order_id : this.$route.params.key,
          href: `/unload/${this.$route.params.key}`,
          active: true
        }
      ];
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model)
        ? []
        : [
            {
              key: "ID Folder",
              item: this.model.ticketable.ticket,
              value: {
                props: {
                  item: {
                    type: Object, default: () => {
                    }
                  }
                },
                template:
                  '<router-link :to="`/tickets/${item.id}`">{{ `${item.id} (${this.$t(`tickets.customer_types.${item.customer_type}`)})` }}</router-link>'
              },
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true
            },
            {
              key: "ID Nota Armada",
              item: this.model.trip_id,
              value: {
                props: { item: { type: Object, default: () => {} } },
                template: '<router-link :to="`/trips/${item}`">{{ `${item}` }}</router-link>'
              },
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true
            },
            {
              key: this.lodash.startCase("pabrik"),
              value: this.model?.trip?.customer
                ? `${this.model.trip.customer.name} (${this.model.trip.customer.code})`
                : "-",
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true
            },
            {
              key: this.lodash.startCase("tanggal nota bongkar"),
              value: this.$moment
                .utc(this.model.ordered_at)
                .local()
                .format("DD MMMM YYYY"),
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true
            },
            {
              key: this.lodash.startCase("supir"),
              value: this.model?.trip?.driver?.name
                ? `${this.model?.trip?.driver?.name} - ${this.model?.trip?.driver?.phone_number}`
                : "-",
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true
            },
            {
              key: this.lodash.startCase("kendaraan"),
              item: this.model?.trip?.vehicle,
              value: {
                props: {
                  item: {
                    type: Object,
                    default() {
                      return [];
                    }
                  }
                },
                computed: {
                  customLabel() {
                    return `${this.lodash.upperFirst(this.vehicleName)} - ${this.item.license_plate}`;
                  },
                  vehicleName() {
                    let label = this.item?.name;

                    if (this.item?.type === "heavy") label = this.$t("vehicles.truck");
                    else if (this.item?.type === "medium") label = this.$t("vehicles.crank_truck");
                    else if (this.item?.type === "light") label = this.$t("vehicles.pickup");

                    return label;
                  }
                },
                template: `<span v-html="customLabel"></span>`
              },
              // value: this.model?.trip?.vehicle?.name
              //   ? `${this.model?.trip?.vehicle?.name} - ${this.model?.trip?.vehicle?.license_plate}`
              //   : "-",
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true
            },
            {
              key: this.lodash.startCase(this.$t("unloads.fibers")),
              value: this.$numeral(this.model.box).format("0,0"),
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true
            },
            {
              key: this.$t(`purchase_orders.file`),
              item: this.model.files,
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    }
                  }
                },
                template: `
                    <div>
                      <div class="row g-0 description-detail">
                        <div class="col-6 value">
                          <attachment
                            :files="item"
                            v-if="item.length"
                          ></attachment>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </div>
                `
              }
            },
            {
              key: this.lodash.startCase("item nota bongkar"),
              item: this.model.sale_items,
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    }
                  }
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "_index",
                        label: "No",
                        sortable: false,
                        style: {width: "1%"}
                      },
                      // {
                      //   key: "shrimp.name",
                      //   label: "Layanan Produk"
                      // },
                      // {
                      //   key: "shrimp.fee",
                      //   label: "Fee"
                      // },
                      {
                        key: "trip_item.purchase_item.size",
                        label: "Size",
                        thClass: "text-center"
                      },
                      {
                        key: "trip_item.purchase_item.quantity",
                        label: "Biomassa",
                        thClass: "text-center",
                        tdClass: "text-center",
                        formatter: value => {
                          return value !== null ? this.$numeral(value).format("0,0.[00]") + " Kg" : "";
                        }
                      },
                      {
                        key: "trip_item.purchase_item.estimated_size",
                        label: "Size",
                        thClass: "text-center",
                        tdClass: "text-center",
                        formatter: value => {
                          return value ? this.$numeral(value).format("0,0.[00]") : "";
                        }
                      },
                      {
                        key: "trip_item.purchase_item.estimated_quantity",
                        label: "Biomassa",
                        thClass: "text-center",
                        tdClass: "text-center",
                        formatter: value => {
                          return value !== null ? this.$numeral(value).format("0,0.[00]") + " Kg" : "";
                        }
                      },
                      {
                        key: "size",
                        label: "Size",
                        thClass: "text-center",
                        tdClass: "text-center"
                      },
                      {
                        key: "quantity",
                        label: "Biomassa",
                        thClass: "text-center",
                        tdClass: "text-center",
                        formatter: value => {
                          return (value ? this.$numeral(value).format("0,0.[00]") : "") + " Kg";
                        }
                      },
                      {
                        key: "size_performance",
                        label: "Size",
                        thClass: "text-center",
                        tdClass: data => {
                          let classes = "text-center";
                          if (data >= 5) {
                            classes += " bg-success";
                          } else {
                            classes += " bg-danger";
                          }
                          return classes;
                        },
                        formatter: value => {
                          return (value ? this.$numeral(value).format("0,0.[00]") : "0") + "%";
                        }
                      },
                      {
                        key: "quantity_performance",
                        label: "Biomassa",
                        thClass: "text-center",
                        tdClass: (data, key, row) => {
                          let classes = "text-center";
                          if (row._index) {
                            if (data >= 5) {
                              classes += " bg-success";
                            } else {
                              classes += " bg-danger";
                            }
                          }
                          return classes;
                        },
                        value: {
                          props: { item: { type: String, default: "" } },
                          template: `<span></span>`
                        },
                        formatter: value => {
                          return value !== null ? this.$numeral(value).format("0,0.[00]") + "%" : "";
                        }
                      },
                      {
                        key: "quality",
                        label: this.lodash.startCase(this.$t("unloads.quality"))
                      },
                      {
                        key: "unit_price",
                        label: "Harga Satuan Bongkar",
                        formatter: value => {
                          return value ? this.$numeral(value).format("$ 0,0.[00]") : "";
                        }
                      },
                      {
                        key: "total_price",
                        label: "Jumlah Harga Bongkar",
                        formatter: value => {
                          return value ? this.$numeral(value).format("$ 0,0.[00]") : "";
                        }
                      }
                    ];
                  },
                  rowClass() {
                    return "";
                  }
                },
                template:
                  '<b-table bordered :tbody-tr-class="rowClass" :fields="fields" :items="item">' +
                  '<template #cell(index)="data">{{ data.index + 1 }}</template>' +
                  `
                <template #thead-top="data">
                  <b-tr>
                    <b-th colspan="3"><span class="sr-only">Name and ID</span></b-th>
                    <b-th variant="" colspan="2" class="text-center">NOTA PANEN</b-th>
                    <b-th variant="" colspan="2" class="text-center">ESTIMASI</b-th>
                    <b-th variant="" colspan="2" class="text-center">NOTA BONGKAR</b-th>
                    <b-th variant="" colspan="2" class="text-center">PERFORMANCE</b-th>
                    <b-th colspan="3"><span class="sr-only">Name and ID</span></b-th>
                  </b-tr>
                </template>
                ` +
                  "</b-table>"
              },
              variant: "performance"
            },
            {
              key: "",
              item: this.model.summaries,
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    }
                  }
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "initial_biomassa_total",
                        thClass: "text-center",
                        tdClass: "text-center",
                        label: "Total Biomassa Nota Armada",
                        formatter: value => {
                          return (value ? this.$numeral(value).format("0,0.[00]") : "") + " Kg";
                        }
                      },
                      {
                        key: "estimated_biomassa_total",
                        thClass: "text-center",
                        tdClass: "text-center",
                        label: "Total Biomassa Estimasi",
                        formatter: value => {
                          return (value ? this.$numeral(value).format("0,0.[00]") : "") + " Kg";
                        }
                      },
                      {
                        key: "actual_biomassa_total",
                        thClass: "text-center",
                        tdClass: "text-center",
                        label: "Total Biomassa Nota Bongkar",
                        formatter: value => {
                          return (value ? this.$numeral(value).format("0,0.[00]") : "") + " Kg";
                        }
                      },
                      {
                        key: "average_biomass_performance",
                        thClass: "text-center",
                        tdClass: "text-center",
                        label: this.lodash.startCase(this.$t("unloads.average_performance_of_unloaded_biomass")),
                        formatter: value => `${this.$numeral(value).format("0,0.[00]")} %`
                      },
                      {
                        key: "unload_total",
                        thClass: "text-center",
                        tdClass: "text-center",
                        label: "Total Harga Bongkar",
                        formatter: value => {
                          return value ? this.$numeral(value).format("$ 0,0.[00]") : "-";
                        }
                      }
                    ];
                  }
                },
                template: '<b-table bordered :fields="fields" :items="item">' + "</b-table>"
              }
            },
            {
              key: `Biaya ditanggung JALA`,
              item: this.model.sale_paid_by_jala,
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    }
                  }
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "index",
                        label: "No",
                        sortable: false,
                        style: { width: "1%" }
                      },
                      {
                        key: "name",
                        label: `${this.lodash.startCase(this.$t("additional_fees.name"))}`,
                        thClass: "text-end",
                        tdClass: "text-end",
                        thStyle: { width: "50%" }
                      },
                      {
                        key: "total",
                        label: `${this.lodash.startCase(this.$t("additional_fees.total"))}`,
                        thClass: "text-end",
                        tdClass: "text-end",
                        thStyle: { width: "50%" },
                        formatter: value => this.$numeral(Math.abs(value)).format("$ 0,0.[00]")
                      }
                    ];
                  }
                },
                template:
                  '<b-table :fields="fields" :items="item">' +
                  '<template #cell(index)="data">{{ data.index + 1 }}</template>' +
                  "</b-table>"
              }
            },
            {
              key: this.lodash.startCase("biaya diteruskan ke mitra"),
              item: this.model.sale_paid_by_partner,
              _denyShow: this.model?.sale_items?.[0]?.product?.code === "jala_panen",
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    }
                  }
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "index",
                        label: "No",
                        sortable: false,
                        style: { width: "1%" }
                      },
                      {
                        key: "name",
                        label: `${this.lodash.startCase(this.$t("additional_fees.name"))}`,
                        thClass: "text-end",
                        tdClass: "text-end",
                        thStyle: { width: "50%" }
                      },
                      {
                        key: "total",
                        label: `${this.lodash.startCase(this.$t("additional_fees.total"))}`,
                        thClass: "text-end",
                        tdClass: "text-end",
                        thStyle: { width: "50%" },
                        formatter: value => this.$numeral(Math.abs(value)).format("$ 0,0.[00]")
                      }
                    ];
                  }
                },
                template:
                  '<b-table :fields="fields" :items="item">' +
                  '<template #cell(index)="data">{{ data.index + 1 }}</template>' +
                  "</b-table>"
              }
            },
            {
              key: "Total Penjualan",
              value: this.model.total ? this.$numeral(this.model.total).format("$ 0,0.[00]") : "",
              label: "Total Penjualan",
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true
            },
            {
              key: this.lodash.startCase("catatan"),
              item: this.model.description,
              value: {
                props: { item: { type: String, default: "" } },
                template: `<span v-html="item || '-'"></span>`
              },
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true
            },
            {
              key: this.lodash.startCase("dibuat pada"),
              value: this.$moment
                .utc(this.model.created_at)
                .local()
                .format("DD MMMM YYYY"),
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              styles: { fontSize: "10px", opacity: "0.8" }
            },
            {
              key: this.lodash.startCase("dibuat oleh"),
              value: this.model.creator?.name,
              class: "row",
              labelClass: "col-sm-12 col-md-2",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              styles: { fontSize: "10px", opacity: "0.8" }
            }
          ].filter(item => !item._denyShow);
    }
  },
  methods: {
    getModelName() {
      return this.model["order_id"];
    },
    delete() {
      return this.$axios.delete(`/sale_orders/${this.$route.params.key}`);
    },
    fetchModel() {
      this.loading = true;
      return this.$axios
        .get(`/sale_orders/${this.$route.params.key}`, {
          params: {
            with: [
              'ticketable.ticket',
              'customer',
              'farmer',
              'sale_items',
              'creator',
              'files',
              'sale_additional_items',
              'creator',
              'customer',
              'purchase_payments',
              'ticket',
              'ticketable',
              'tickets.sale_orders.sale_payments',
              'sale_items.product',
              'sale_items.purchase_item',
              'trip.driver',
              'trip.vehicle',
              'trip.trip_items.purchase_item.purchase_order.product',
              'sale_items.trip_item.purchase_item,trip.customer'
            ].join(','),
          }
        })
        .then(response => {
          const {
            data: { data }
          } = response;
          let purchase_order_ids = [];

          purchase_order_ids = [...new Set(purchase_order_ids)].join(", ");
          this.model = {
            ...data,
            purchase_order_ids,
            actual_sale_items: data.sale_items
              .filter(item => !item.purchase_item)
              .map(item => ({
                ...item,
                debt: item.quantity * item.purchase_item.purchaseorder.service_fee
              })),
            trip: {
              ...data.trip,
              trip_items: data.trip.trip_items.map(item => ({
                ...item,
                // order by trip_item_id
                sale_items: data.sale_items
                  .filter(sale_item => sale_item.trip_item_id === item.id)
                  .sort((a, b) => a.trip_item_id - b.trip_item_id)
                // only display trip_item_id on first occurence
              }))
            }
          };
          this.model.sale_items = this.model.sale_items.sort((a, b) => a.trip_item_id - b.trip_item_id);
          const trip_item_ids = [];
          this.model.sale_items = this.model.sale_items.map(item => {
            if (!trip_item_ids.includes(item.trip_item_id)) {
              trip_item_ids.push(item.trip_item_id);
              item._index = trip_item_ids.length;
              if (item._index) {
                item.rowspan = this.model.sale_items.filter(
                  sale_item => sale_item.trip_item_id === item.trip_item_id
                ).length;
              }
              item.estimated_size = item.initial_size * 0.9;
              item.estimated_quantity = item.initial_quantity * 1.12;
              const totalQuantity =
                Math.round(
                  this.model.sale_items
                    .filter(sale_item => sale_item.trip_item_id === item.trip_item_id)
                    .reduce((acc, cur) => acc + cur.quantity, 0) * 100
                ) / 100;
              const totalInitialQuantity = Math.round(item.initial_quantity * 100) / 100;
              item.quantity_performance =
                totalInitialQuantity > 0 ? ((totalQuantity - totalInitialQuantity) / totalInitialQuantity) * 100 : 0;
            } else {
              item.trip_item_id = null;
              item.shrimp = null;
              item.trip_item = null;
              item.quantity_performance = null;
            }
            return item;
          });
          this.model.sale_paid_by_jala = data.sale_additional_items
            .filter(v => v.paid_by == "jala")
            .map(v => ({ ...v, total: Math.abs(v.total) }));
          this.model.sale_paid_by_partner = data.sale_additional_items
            .filter(v => v.paid_by == "partner")
            .map(v => ({ ...v, total: Math.abs(v.total) }));
          const defaultPaidByJala = [
            { name: "Diskon", total: 0, disabled: true, paid_by: "jala" },
            {
              name: "Biaya Percepatan",
              total: 0,
              disabled: true,
              paid_by: "jala"
            }
          ];
          const defaultPaidByPartner = [
            { name: "Diskon", total: 0, disabled: true, paid_by: "partner" },
            { name: "PPH 22", total: 0, disabled: true, paid_by: "partner" },
            { name: "Moulting", total: 0, disabled: true, paid_by: "partner" }
          ];
          if (this.model.sale_paid_by_jala.length == 0) {
            this.model.sale_paid_by_jala = defaultPaidByJala;
          } else {
            defaultPaidByJala.forEach(item => {
              const index = this.model.sale_paid_by_jala.findIndex(v => v.name == item.name);
              if (index >= 0) {
                this.model.sale_paid_by_jala[index].disabled = true;
              }
            });
          }
          if (this.model.sale_paid_by_partner.length == 0) {
            this.model.sale_paid_by_partner = defaultPaidByPartner;
          } else {
            defaultPaidByPartner.forEach(item => {
              const index = this.model.sale_paid_by_partner.findIndex(v => v.name == item.name);
              if (index >= 0) {
                this.model.sale_paid_by_partner[index].disabled = true;
              }
            });
          }

          const summaries = [
            {
              initial_biomassa_total: this.model.sale_items.reduce((total, item) => total + item.initial_quantity, 0),
              estimated_biomassa_total: this.model.sale_items.reduce((acc, item) => {
                return acc + item.initial_quantity * 1.12;
              }, 0),
              actual_biomassa_total: this.model.sale_items.reduce((total, item) => total + item.quantity, 0),
              average_biomass_performance: data.quantity_performance,
              unload_total: this.model.sale_item_total
            }
          ];
          this.model.summaries = summaries;
          return response;
        })
        .catch(error => this.failedAlert(error))
        .finally(() => (this.loading = false));
    }
  }
};
</script>
